import React from "react";
import Navbar from "../Components/Navbar";
import Hero from "../Components/Hero";
import travel1 from "../assets/travel1.jpg";
import Destination from "../Components/Destination";
import Trip from "../Components/Trip";
import Footer from "../Components/Footer";
import ContactForm from "../Components/ContactForm";
import Faq from "../Components/Faq";
// import Accord from "../Components/Accord";

const Home = () => {
  return (
    <div>
      <Navbar />
      <Hero
        cName="hero"
        heroImg={travel1}
        title="Your Journey Your Story"
        text="Explore Beautiful Places"
        buttonText="Travel Plan"
        url="/"
        btnClass="show"
      />
      <Destination />
      {/* <Accord /> */}
      <Faq />
      <Trip />
      <ContactForm />
      <Footer />
    </div>
  );
};

export default Home;
